import { render, staticRenderFns } from "./SessionsArea.vue?vue&type=template&id=00b091a2"
import script from "./SessionsArea.vue?vue&type=script&lang=js"
export * from "./SessionsArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports